import React from 'react'

export default function Loading() {
    return (
        <div className="loading">
            <i className="fa-solid fa-spinner-third fa-spin"></i>
        </div>
    )
}
